import type { PermissionType } from '@thinkalpha/common/contracts/permissions.js';
import type { Route } from '@thinkalpha/ui-types/types/admin/lab';
import { getAllowSubjectIds } from 'src/admin/lib/permissions';

type EntityWithRoutePermission = {
    access: PermissionType;
    id: string;
    routeId: string;
    routeName: string;
};
export const getEntitiesWithRoutePermission = (route: Route): EntityWithRoutePermission[] => {
    const { permissions } = route;
    return Object.entries(permissions)
        .flatMap(([key, _]) => {
            if (key !== 'admins' && key !== 'owners' && key !== 'readers' && key !== 'writers') return;
            return (
                permissions[key] &&
                getAllowSubjectIds(permissions[key]).map((id) => ({
                    access: (key === 'admins'
                        ? 'admin'
                        : key === 'owners'
                          ? 'owner'
                          : key === 'readers'
                            ? 'reader'
                            : 'writer') as PermissionType,
                    id,
                    routeId: route.id,
                    routeName: route.name,
                }))
            );
        })
        .filter((x) => !!x);
};
